$(document).on('ready turbolinks:load', function() {
  $("#room_is_group").on('change', room_is_group_changed);
  $("#room_is_group").trigger('change');

  $("#add_rooms_into_group").on('click', function() {
    $("select[name='rooms_in_facility[]'] option:selected").each(function() {
      $("select[name='room[room_group_members][]']").append($('<option>').html($(this).text()).val($(this).val()))
    });
    var item = $("select[name='room[room_group_members][]']").children().sort(sort_by_text);
    $("select[name='room[room_group_members][]']").append(item);
    $("select[name='rooms_in_facility[]'] option:selected").remove();
  })

  $("#remove_rooms_from_group").on('click', function() {
    $("select[name='room[room_group_members][]'] option:selected").each(function() {
      $("select[name='rooms_in_facility[]']").append($('<option>').html($(this).text()).val($(this).val()))
    });
    var item = $("select[name='rooms_in_facility[]']").children().sort(sort_by_text);
    $("select[name='rooms_in_facility[]']").append(item);
    $("select[name='room[room_group_members][]'] option:selected").remove();
  })

  $("select[name='room[reservation_method]']").on('change', reservation_method_changed);
  $("select[name='room[reservation_method]']").trigger('change');

  lock_type_load_setting();

  // モーダルダイアログ内にselect name="user_id"がある時のみ限定で処理する (現在は部屋の情報画面と部屋の一覧画面のみ)
  //   (issue#467 空室カレンダー画面で動作しないように修正)
  if ($(".modal-body select[name='user_id']").length > 0) {
    $("select[name='user_id']").change(function() {
      // 部屋の数だけダイアログが出来てしまうため、すべてのダイアログの選択を見るように
      $("select[name='user_id']").each(function() {
        // 同一modal(ダイアログ)上のfooterを変更対象とする
        var footer = $(this).parents('.modal-content').find(".modal-footer-button");
        if (footer != null){
          var val = $(this).val();
          if (val == ''){
            footer.hide();
          } else {
            footer.show();
          }
        }
      });
    })
    $("select[name='user_id']").trigger('change');
  }

  $(".edit-room-form input[type='submit'].activate-room-group-members").on('click', function() {
    pre_edit_room_submit();
    return true
  });

  var use_report_form_sel = '.edit-room-form';
  var use_report_model = 'room';
  var use_report_el = $(`${use_report_form_sel} select[name='${use_report_model}[use_report]']`);
  var use_report_template_id_el = $(`${use_report_form_sel} select[name='${use_report_model}[use_report_template_id]']`);

  // 「利用報告機能」選択に応じ「利用報告書」表示切替
  use_report_el.on('change', function() {
    if ($(this).val() == 'enabled') {
      // 表示
      $(`${use_report_form_sel} .use-report-template`).slideDown();
    } else {
      // 非表示
      $(`${use_report_form_sel} .use-report-template`).slideUp();
    }
  });
  use_report_el.trigger('change');

  $('#room_save').on('click', function() {
    var val_group = $("select[name='room[room_group_members][]']").text();
    var val_method = $("select[name='room[reservation_take_method]']").val();

    let msgFlg = false;

    if ($("input[name='room[is_group]']:checkbox").prop('checked')) {
      // 親部屋
      // 子部屋に異なる予約部屋がいればダイアログを出す。
      if (val_method == "first") {
        if (val_group.indexOf("[抽]") != -1) {
          msgFlg = true;
        }
      } else {
        if (val_group.indexOf("[先]") != -1) {
          msgFlg = true;
        }
      }
    } else {
      // 子部屋でreservation_take_methodが変更されたならばダイアログを出す。
      if (g_belongs_to_group && (val_method != g_previous_reservation_take_method)) {
        msgFlg = true;
      }
    }

    let checkMoveFlg = true;
    if (msgFlg == true) {
      checkMoveFlg = window.confirm('属する部屋グループ・その部屋グループに属する部屋など、\n関連する部屋について同様の予約の受付方法で更新されます。\n\nよろしいですか？');
    }
    if(checkMoveFlg == false) {
      return false
    }

    // 「利用報告書機能」が「利用する」なのに「利用報告書」が未選択
    //   (施設/所管(common.js)と異なり「未選択」選択肢がないのでnullと比較)
    if (use_report_el.val() == 'enabled' && use_report_template_id_el.val() == null) {
      alert('利用報告書を選択してください');
      return false;
    }

    pre_edit_room_submit();
    return true
  });

  //「申請内容を選択してください」が表示されている時、ボタンを無効化
  var requested_setting_toggleButton = function(modal) {
    const buttonElement = modal.querySelector('.modal-footer-button #requested-setting-submit-btn');
    const selectElement = modal.querySelector('#requested-setting-select');
    if (!selectElement) return;
    const promptMessage = selectElement.options[selectElement.selectedIndex].text;

    if (promptMessage === '申請内容を選択してください') {
      buttonElement.disabled = true;
      $(buttonElement).addClass("btn-nonactive");
    } else {
      buttonElement.disabled = false;
      $(buttonElement).removeClass("btn-nonactive");
    }
  };
  //部屋の一覧ページにおいて、空室カレンダーボタンを開くたびにボタンの状態を設定
  $('[id^=reservation_modal_]').on('show.bs.modal', function() {
    const modal = $(this)[0];  // jQuery から DOM 要素に変換
    requested_setting_toggleButton(modal);  
    $(modal).find("#requested-setting-select").change(function() {
      requested_setting_toggleButton(modal);  // セレクトボックスの変更に応じて制御
    });
  });
});

$(window).on('pageshow', function() {
  $("#room_is_group").trigger('change');
  $("select[name='room[reservation_method]']").trigger('change');
  // モーダルダイアログ内にselect name="user_id"がある時のみ限定で処理する (現在は部屋の情報画面と部屋の一覧画面のみ)
  //   (issue#467 空室カレンダー画面で動作しないように修正)
  if ($(".modal-body select[name='user_id']").length > 0) {
    $("select[name='user_id']").trigger('change');
  }
  lock_type_load_setting();
});

function room_is_group_changed() {
  if ($("#room_is_group").prop('checked')) {
    $(".room_group").slideDown();
    /*$(".display_raffle").slideUp();
    $(".display_first").slideDown();
    document.getElementById("room_reservation_take_method").querySelector("option[value='first']").selected = true;*/
  } else {
    $(".room_group").slideUp();
    /*$(".display_raffle").slideDown();
    $(".display_first").slideUp();*/
  }
}

function reservation_method_changed() {
  var val = $("select[name='room[reservation_method]']").val();
  if (val == "optional") {
    $(".room_select_unit").slideDown()
  } else {
    $(".room_select_unit").slideUp()
  }
}

function lock_type_load_setting() {
  var val = $("select[name='room[lock_type]']").val();
  if (val == "none") {
    $(".room_lock_serial").slideUp()
    $(".room_lock_master_pin").slideUp();
    $(".room_validity_period_margin_before").slideUp()
    $(".room_validity_period_margin_after").slideUp()
  } else {
    $(".room_lock_serial").slideDown()
    $(".room_validity_period_margin_before").slideDown();
    $(".room_validity_period_margin_after").slideDown();

    if (val == "remotelock" || val == "remotelock_mynumber") {
      $(".room_lock_master_pin").slideDown();
      $(".room_lock_serial_igloo").slideUp();
      $(".room_lock_serial_remotelock").slideUp();
      $("#validity_period_margin_before_hour").slideUp();
      $("#validity_period_margin_after_hour").slideUp();
      $("#validity_period_margin_before_min").slideDown();
      $("#validity_period_margin_after_min").slideDown();
    } else if (val == "igloo") {
      $(".room_lock_master_pin").slideUp();
      $(".room_lock_serial_igloo").slideDown();
      $(".room_lock_serial_remotelock").slideUp();
      $("#validity_period_margin_before_min").slideUp();
      $("#validity_period_margin_after_min").slideUp();
      $("#validity_period_margin_before_hour").slideDown();
      $("#validity_period_margin_after_hour").slideDown();
    }
  }
}

function pre_edit_room_submit() {
  $('#room_room_group_members option').prop("selected", true);
}

function sort_by_text(a, b) {
  var val_a1 = a.text.substr(0, 3);
  var val_a2 = a.text.slice(3).trim();
  var val_b1 = b.text.substr(0, 3);
  var val_b2 = b.text.slice(3).trim();

  var val = $("select[name='room[reservation_take_method]']").val();
  if (val == "first") {
    if (val_a1 <= val_b1 && val_a2 > val_b2) {
      if (val_a1 != val_b1) {
        return -1;
      } else {
        return 1;
      }
    } else if (val_a1 <= val_b1 && val_a2 < val_b2) {
      return -1;
    } else {
      return 0;
    }
  } else {
    if (val_a1 >= val_b1 && val_a2 > val_b2) {
      if (val_a1 != val_b1) {
        return -1;
      } else {
        return 1;
      }
    } else if (val_a1 >= val_b1 && val_a2 < val_b2) {
      return -1;
    } else {
      return 0;
    }
  }
}